import React from 'react';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import EventEntriesAthletesTable from "components/common/entries/EventEntriesAthletesTable"
import { ALL_URL } from 'helpers/utils';

export default function EntriesByEvent({data}) {
    const {mirs_discipline, mirs_event } = useUrlFriendlyToParameters();
    const [dataState, setDataState] = React.useState([]);
    
    React.useEffect(() => {
        let filterData = data;
        filterData = filterData?.filter(row => row.mainFunction?.functionCode === 'AA01');
        if (mirs_discipline && mirs_discipline !==  ALL_URL.ALL_DISC) {
            filterData = filterData?.filter(item => item?.disciplines?.some(d => d?.code === mirs_discipline))
        }
        // if (mirs_event && mirs_event !==  ALL_URL.ALL_EVENT) {
        //     filterData = filterData?.filter(item => item?.registeredEvents?.some(e => e?.code === mirs_event));
        // }
        if (mirs_event && mirs_event !== ALL_URL.ALL_EVENT) {
            filterData = filterData?.map(athlete => 
                ({
                    ...athlete,
                    registeredEvents: athlete?.registeredEvents?.filter(event => event?.code === mirs_event)
                })
            )?.filter(athlete => athlete?.registeredEvents?.length > 0);
        }

        setDataState(filterData);
        }, [data, mirs_event, mirs_discipline]);    
    return (<> {dataState && <EventEntriesAthletesTable data={dataState} key={`athletes`} />} </>)
};

